/* unplugin-vue-components disabled */import { render } from "./NoShiptos.vue?vue&type=template&id=f7822d88"
import script from "./NoShiptos.vue?vue&type=script&lang=js"
export * from "./NoShiptos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__